<template>
  <div class="pa-6 text-center">Completing sign-out…</div>
</template>

<script setup>
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();

onMounted(async () => {
  await auth.completeLogout();
  await auth.recoverToLogin("signed_out", "/");
});
</script>
